'use strict';

//import $ from "jquery";
import ImageLoad from "./ImageLoad";
import SubImages from "./SubImages";
import Lang from "./Lang";
import Constants from "./Constants";

class Store {
    constructor() {

        this.imgLoad = new ImageLoad();
        this.subImages = new SubImages();

        this.lang = new Lang();

        this.itemKbn = Constants.itemKbn;

        // 商品データ
        this.itemData = {
            hakko_number: "",
            brand_name: "",
            item_name: "",
            model_no: "",
            serial_no: "",
            material: "",
            movement: "",

            color: "",
            face: "",
            koma_count: "",
            stone_name: "",
            size: "",
            card_count: "",
            weight: "",
            accesories: "",
            specification: "",
            line_name: "",

            item_kbn: "",
            hakko_date: "",
            hakko_date_view: "",

            sougou: "",
            rank_name: "",
            outer_rank_name: "",
            remark: "",
            spin_images: [],
            html_preview: "",

            tekiyou: "",

        }


        // 商品ステータス
        this.itemStatus = {
            // 外側
            outer: {

                // 金具
                metal: {
                    //henshoku: 0,
                    //yogore: 0,
                    //sure: 0,
                    //rekka: 0,
                    //sabi: 0,
                    kadoufuryou: 0,
                    //kizu: 0,
                    hason: 0,
                    //dakon: 0
                }

            },

            // 内側
            inner: {

                // 表面素材
                surface: {
                    henshoku: 0,
                    yogore: 0,
                    rekka: 0,
                    hagare: 0,
                    hason: 0,
                    uchiana: 0,
                    itohoture: 0,
                    pennato: 0,
                    kizu: 0,
                    beta: 0,
                    nioi: 0,
                    pennato_name: 0,
                    logokasure: 0,
                    dakon: 0
                },

                // 革
                leather: {
                    henshoku: 0,
                    yogore: 0,
                    rekka: 0,
                    kiresou: 0,
                    hason: 0,
                    sure: 0,
                    itohoture: 0,
                    pennato: 0,
                    kizu: 0,
                    dakon: 0
                },

                // 金具
                metal: {
                    henshoku: 0,
                    yogore: 0,
                    sure: 0,
                    rekka: 0,
                    sabi: 0,
                    kadoufuryou: 0,
                    kizu: 0,
                    hason: 0,
                    dakon: 0
                }

            },

            // 時計
            watch: {
                outer: {
                    brace: {
                        tare: 0,
                    }
                },
                loupe: {
                    glass: {
                        kizu: 0,
                        corting: 0,
                    },
                    needle: {
                        kizu: 0,
                        henshoku: 0,
                        sabi: 0,
                        fushoku: 0,
                    },
                    face: {
                        kizu: 0,
                        hibi: 0,
                        hokori: 0,
                        aburashinto: 0,
                        fushoku: 0,
                    },
                    bezel: {
                        ishikake: 0,
                        daizayugami: 0,
                    },
                    buckle: {
                        kokuinmamou: 0,
                    },
                }
            },

            // ジュエリー
            jewely: {
                outer: {
                    metal: {
                        furyou: 0,
                        hekomi: 0,
                    },
                    body: {
                        mekkihagare: 0,
                        henshoku: 0,
                        koware: 0,
                    },
                    stone: {
                        hibi: 0,
                        ishiochi: 0,
                    }
                },
                detail: {
                    dia: {
                        kumori: 0,
                        kizu: 0,
                        hibi: 0,
                        kake: 0,
                    },
                    gem: {
                        kumori: 0,
                        kizu: 0,
                        hibi: 0,
                        kake: 0,
                    },
                    kokuin: {
                        usuikezure: 0,
                        kezure: 0,
                        kokuinnashi: 0,
                    },
                    metal: {
                        henshoku: 0,
                        kizu: 0,
                        ware: 0,
                        hekomi: 0,
                        sabi: 0,
                        hason: 0,
                        yore: 0,
                    },
                }
            }

        }

        // サブ画像データ
        this.subImageData = {
            title1: "",
            title2: "",
            title3: "",
            title4: "",
            title5: "",
            title6: "",
            comment1: "",
            comment2: "",
            comment3: "",
            comment4: "",
            comment5: "",
            comment6: "",
        }




    }

    /**
     * ストアされているデータをクリアする.
     */
    clearStoreDatas() {

        // 商品データ
        for (let idx in this.itemData) {
            this.itemData[idx] = '';
        }

        // ステータス
        this.clearStatusDataRow(this.itemStatus.outer.metal);
        this.clearStatusDataRow(this.itemStatus.inner.surface);
        this.clearStatusDataRow(this.itemStatus.inner.leather);
        this.clearStatusDataRow(this.itemStatus.inner.metal);

        this.clearStatusDataRow(this.itemStatus.watch.outer.brace);
        this.clearStatusDataRow(this.itemStatus.watch.loupe.glass);
        this.clearStatusDataRow(this.itemStatus.watch.loupe.niddle);
        this.clearStatusDataRow(this.itemStatus.watch.loupe.face);
        this.clearStatusDataRow(this.itemStatus.watch.loupe.bezel);
        this.clearStatusDataRow(this.itemStatus.watch.loupe.buckle);

        this.clearStatusDataRow(this.itemStatus.jewely.outer.metal);
        this.clearStatusDataRow(this.itemStatus.jewely.outer.body);
        this.clearStatusDataRow(this.itemStatus.jewely.outer.stone);
        this.clearStatusDataRow(this.itemStatus.jewely.detail.dia);
        this.clearStatusDataRow(this.itemStatus.jewely.detail.gem);
        this.clearStatusDataRow(this.itemStatus.jewely.detail.kokuin);
        this.clearStatusDataRow(this.itemStatus.jewely.detail.metal);

        // サブ画像データ
        for (let idx in this.subImageData) {
            this.subImageData[idx] = '';
        }

    }

    /**
     * 1行のステータスクリア.
     */
    clearStatusDataRow(obj) {

        for (let idx in obj) {
            obj[idx] = '';
        }

    }


    /**
     * 商品データの表示.
     */
    fillItemData() {

        for (let idx in this.itemData) {

            let domObj = document.getElementById(idx);
            if (domObj) {
                if (this.itemData[idx] === null) {
                    domObj.innerHTML = '';
                } else {
                    domObj.innerHTML = this.nl2br(this.itemData[idx]);
                }
            }
        }

        this.showIteminfoSubData();

        // 摘要は無ければ表示しない
        $('.tekiyouContainer').removeClass('show');
        if (this.itemData.tekiyou !== '' && this.itemData.tekiyou !== null) {
            $('.tekiyouContainer').addClass('show');
        }



        //$('#iframeSpin iframe').attr('src', 'http://157.7.215.104/talgradingreport' + this.itemData.html_preview)


        // 画像表示
        var imgPath = '';
        $('.subImageContainer').removeClass('show');

        if (this.itemData.hakko_date !== '' && this.itemData.hakko_date !== null) {

            var tmp = this.itemData.hakko_date.split('/');

            // 通常表示 ---
            $('#imgContainerMain').addClass('show');
            $('#imgContainerSpin').removeClass('show');
            $('#iframeSpin').removeClass('show');

            // HTML⇒spin⇒通常の順に優先
            if (this.itemData.html_preview !== null && this.itemData.html_preview.length > 0) {

                this.imgLoad.loadHtmlFrame(this.itemData.html_preview);
                $('#imgContainerMain').removeClass('show');
                $('#iframeSpin').addClass('show');

            } else if (this.itemData.spin_images != null && this.itemData.spin_images.length > 0) {

                imgPath = '/' + tmp[0] + '/' + tmp[1] + '/' + this.itemData.hakko_number + '/spins/';
                this.imgLoad.loadSpinImage(imgPath, this.itemData.spin_images);
                $('#imgContainerMain').removeClass('show');
                $('#imgContainerSpin').addClass('show');


            } else {

                imgPath = '/' + tmp[0] + '/' + tmp[1] + '/' + this.itemData.hakko_number + '/Main.jpg';
                this.imgLoad.loadImage(imgPath);

            }

            // サブ画像
            imgPath = '/' + tmp[0] + '/' + tmp[1] + '/' + this.itemData.hakko_number + '/';
            this.subImages.loadSubImages(imgPath);


        } else {
            this.imgLoad.loadImage(null);
        }

        // サブ画像表示
        for (let i = 1; i <= 6; i++) {
            let $subImageContainer = $('#subImage' + i);

            $subImageContainer.find('.card-title').html(this.subImageData['title' + i]);
            $subImageContainer.find('.card-comment').html(this.subImageData['comment' + i]);

        }

        return this;

    }

    /**
     * 商品情報の副情報表示制御.
     */
    showIteminfoSubData() {

        // 副情報はいったん隠す
        $(".subInfo").removeClass("show");

        // ステータス情報はいったん隠す
        $(".statusContainer").removeClass("show");

        var tmpInfo = null;
        switch (this.itemData.item_kbn - 0) {
        case this.itemKbn.bag.code:
        case this.itemKbn.other.code:

            tmpInfo = this.itemKbn.bag.info;
            $('#statusContainerBag').addClass('show');
            break;

        case this.itemKbn.watch.code:
            tmpInfo = this.itemKbn.watch.info;
            $('#statusContainerWatch').addClass('show');
            break;
        case this.itemKbn.jewely.code:
        case this.itemKbn.accessory.code:
            tmpInfo = this.itemKbn.jewely.info;
            $('#statusContainerJewely').addClass('show');
            break;
        default:
            tmpInfo = this.itemKbn.bag.info;
            $('#statusContainerBag').addClass('show');
            break;
        }

        if (tmpInfo !== null) {
            for (let idx in tmpInfo) {
                $("#subinfo_" + tmpInfo[idx]).addClass('show');
            }
        }

    }


    /**
     * 状態の表示処理.
     *
     * public
     */
    fillStatusData() {

        // 外側 -------
        this.fillStatusDataRow(this.itemStatus.outer.metal, '#outer-metal-');

        // 内側 -------
        this.fillStatusDataRow(this.itemStatus.inner.surface, '#inner-surface-');
        this.fillStatusDataRow(this.itemStatus.inner.leather, '#inner-leather-');
        this.fillStatusDataRow(this.itemStatus.inner.metal, '#inner-metal-');

        // 時計
        this.fillStatusDataRow(this.itemStatus.watch.outer.brace, '#watch-outer-brace-');
        this.fillStatusDataRow(this.itemStatus.watch.loupe.glass, '#watch-loupe-glass-');
        this.fillStatusDataRow(this.itemStatus.watch.loupe.needle, '#watch-loupe-needle-');
        this.fillStatusDataRow(this.itemStatus.watch.loupe.face, '#watch-loupe-face-');
        this.fillStatusDataRow(this.itemStatus.watch.loupe.bezel, '#watch-loupe-bezel-');
        this.fillStatusDataRow(this.itemStatus.watch.loupe.buckle, '#watch-loupe-buckle-');

        // ジュエリー
        this.fillStatusDataRow(this.itemStatus.jewely.outer.metal, '#jewely-outer-metal-');
        this.fillStatusDataRow(this.itemStatus.jewely.outer.body, '#jewely-outer-body-');
        this.fillStatusDataRow(this.itemStatus.jewely.outer.stone, '#jewely-outer-stone-');
        this.fillStatusDataRow(this.itemStatus.jewely.detail.dia, '#jewely-detail-dia-');
        this.fillStatusDataRow(this.itemStatus.jewely.detail.gem, '#jewely-detail-gem-');
        this.fillStatusDataRow(this.itemStatus.jewely.detail.kokuin, '#jewely-detail-kokuin-');
        this.fillStatusDataRow(this.itemStatus.jewely.detail.metal, '#jewely-detail-metal-');

        return this;


    }

    /**
     * 状態1行の入力補完.
     *
     * private.
     */
    fillStatusDataRow(obj, idPrefix) {

        for (let idx in obj) {
            let domId = idPrefix + idx;
            let $domObj = $(domId);

            //$domObj.find('.level').text('');
            $domObj.find('input:checkbox').prop('checked', false);

            if (obj[idx] > 0) {
                $domObj.find('input:checkbox').prop('checked', true);
                //$domObj.find('.level').text('(' + obj[idx] + ')');
            }


        }
        return this;
    }


    /**
     * 検索するとデータをセットする.
     */
    setData(obj) {

        if (obj === null) {

            this.clearStoreDatas();

        } else {

            // 商品データ
            for (let idx in this.itemData) {
                this.itemData[idx] = '';
                if (idx in obj) {
                    this.itemData[idx] = obj[idx];
                }
            }

            // 商品ステータス
            // 外側 ---
            this.setStatusDataRow(this.itemStatus.outer.metal, 'outer_metal_', obj)

            // 内側 ---
            this.setStatusDataRow(this.itemStatus.inner.surface, 'inner_surface_', obj)
            this.setStatusDataRow(this.itemStatus.inner.leather, 'inner_leather_', obj)
            this.setStatusDataRow(this.itemStatus.inner.metal, 'inner_metal_', obj)

            // 時計
            this.setStatusDataRow(this.itemStatus.watch.outer.brace, 'watch_outer_brace_', obj)
            this.setStatusDataRow(this.itemStatus.watch.loupe.glass, 'watch_loupe_glass_', obj)
            this.setStatusDataRow(this.itemStatus.watch.loupe.needle, 'watch_loupe_needle_', obj)
            this.setStatusDataRow(this.itemStatus.watch.loupe.face, 'watch_loupe_face_', obj)
            this.setStatusDataRow(this.itemStatus.watch.loupe.bezel, 'watch_loupe_bezel_', obj)
            this.setStatusDataRow(this.itemStatus.watch.loupe.buckle, 'watch_loupe_buckle_', obj)

            // ジュエリー
            this.setStatusDataRow(this.itemStatus.jewely.outer.metal, 'jewely_outer_metal_', obj)
            this.setStatusDataRow(this.itemStatus.jewely.outer.body, 'jewely_outer_body_', obj)
            this.setStatusDataRow(this.itemStatus.jewely.outer.stone, 'jewely_outer_stone_', obj)
            this.setStatusDataRow(this.itemStatus.jewely.detail.dia, 'jewely_detail_dia_', obj)
            this.setStatusDataRow(this.itemStatus.jewely.detail.gem, 'jewely_detail_gem_', obj)
            this.setStatusDataRow(this.itemStatus.jewely.detail.kokuin, 'jewely_detail_kokuin_', obj)
            this.setStatusDataRow(this.itemStatus.jewely.detail.metal, 'jewely_detail_metal_', obj)

            // サブ画像データ
            for (let idx in this.subImageData) {
                if (idx in obj) {
                    this.subImageData[idx] = obj[idx];
                }
            }

            // 表示言語
            let lang = '';
            switch (obj.language - 0) {
            case 1:
                lang = 'en';
                break;
            default:
                lang = 'ja';
                break;
            }
            this.lang.setLanguage(lang, obj.item_kbn);

            }


        return this;
    }

    setStatusDataRow(obj, prefix, data) {
        for (let idx in obj) {
            var key = prefix + idx;

            if (key in data) {
                obj[idx] = data[key];
            }
        }
    }

    nl2br(str) {
        str = str.replace(/\r\n/g, "<br>");
        str = str.replace(/(\n|\r)/g, "<br>");
        return str;
    }


}

export default Store;

